import { computed, defineComponent } from "vue"; // modules

import AuthModule from "@/store/modules/auth"; // components

import { NavbarMainMenu, NavbarDetectInternet, NavbarTabs, NavbarReloadConfig, NavbarScanQrCode } from "@/components/index";
import { useI18n } from "vue-i18n";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
export default defineComponent({
  name: "Navbar",
  components: {
    NavbarDetectInternet: NavbarDetectInternet,
    NavbarMainMenu: NavbarMainMenu,
    NavbarTabs: NavbarTabs,
    NavbarReloadConfig: NavbarReloadConfig,
    NavbarScanQrCode: NavbarScanQrCode
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isAuth = computed(function () {
      return AuthModule.getIsAuth;
    });
    return {
      isAuth: isAuth,
      hasSalesStarted: hasSalesStarted
    };
  }
});